import {
  AFFORDABLE,
  DETAILS,
  ENABLED,
  INCOME_ELIGIBILITY,
  MAX_DETAILS_LENGTH,
  MAXIMUM_INCOME,
  OCCUPANTS,
  VALIDATION_ERROR_MESSAGES,
} from './constants';

const hasIncomeEligibilityChanged = (originalRows = [], updatedRows = []) => {
  if (originalRows.length !== updatedRows.length) {
    return true;
  }

  const originalByOccupants = originalRows.reduce((acc, row) => {
    acc[row[OCCUPANTS]] = row[MAXIMUM_INCOME];
    return acc;
  }, {});

  return updatedRows.some(
    (row) => originalByOccupants[row[OCCUPANTS]] !== row[MAXIMUM_INCOME],
  );
};

export const getHasAffordableChanged = (affordable = {}, affordableTabData) => {
  if (affordable[ENABLED] !== affordableTabData[ENABLED]) {
    return true;
  }

  if (affordable[DETAILS] !== affordableTabData[DETAILS]) {
    return true;
  }

  return hasIncomeEligibilityChanged(
    affordable[INCOME_ELIGIBILITY],
    affordableTabData[INCOME_ELIGIBILITY],
  );
};

export const getAffordableChanges = (affordable = {}, affordableTabData) => {
  const updates = {};
  if (affordable[ENABLED] !== affordableTabData[ENABLED]) {
    updates[ENABLED] = affordableTabData[ENABLED];
  }
  if (affordable[DETAILS] !== affordableTabData[DETAILS]) {
    updates[DETAILS] = affordableTabData[DETAILS];
  }

  if (
    hasIncomeEligibilityChanged(
      affordable[INCOME_ELIGIBILITY],
      affordableTabData[INCOME_ELIGIBILITY],
    )
  ) {
    updates[INCOME_ELIGIBILITY] = affordableTabData[INCOME_ELIGIBILITY];
  }

  return Object.keys(updates).length ? { [AFFORDABLE]: updates } : {};
};

export const getValidationErrorMessages = (affordableTabData) => {
  const details = affordableTabData[DETAILS] ?? '';
  const incomeEligibility = affordableTabData[INCOME_ELIGIBILITY] ?? [];

  const errorMessages = {};

  if (details.length > MAX_DETAILS_LENGTH) {
    errorMessages[DETAILS] = VALIDATION_ERROR_MESSAGES.CHARACTER_LIMIT_EXCEEDED;
  }

  const rowErrors = incomeEligibility.map((row) => {
    const rowError = {};
    if (!row[OCCUPANTS]) {
      rowError[OCCUPANTS] = VALIDATION_ERROR_MESSAGES.REQUIRED;
    }
    if (!row[MAXIMUM_INCOME]) {
      rowError[MAXIMUM_INCOME] = VALIDATION_ERROR_MESSAGES.REQUIRED;
    }
    return rowError;
  });

  const hasRowError = rowErrors.some((rowError) => Object.keys(rowError).length);
  if (hasRowError) {
    errorMessages[INCOME_ELIGIBILITY] = rowErrors;
  }

  return Object.keys(errorMessages).length ? errorMessages : null;
};
